import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

function AddModules() {
  return (
    <>
      <div className="container-fluid p-5 div-ContainerFluid">
        <div className="row bg-white">
          <div className="col-12">
            <div className="div-borderlines p-4">
              <h4 className="fw-bold h4-agduaxjcgshtusa mb-3">
                Add Modules
              </h4>

              <div>

              <p className="fw-bold mb-3">
                Module Details
              </p>

                <div>
                  <Form className="form-scacaz w-50">
                    <p className="mb-3">Module Number</p>
                    <input type="text" className="" placeholder="10" />
                  </Form>
                </div>

                <div>
                  <Form className="form-scacaz w-50">
                    <p className="mb-3">Module Name</p>
                    <input type="text" className="" placeholder="Psychology" />
                  </Form>
                </div>

                <div>
                  <Form className="form-scacaz w-50">
                    <p className="mb-3">Start Date</p>
                    <input
                      type="text"
                      className=""
                      placeholder="Dec 10, 2024"
                    />
                  </Form>
                </div>

                <div>
                  <Form className="form-scacaz w-50">
                    <p className="mb-3">End Date</p>
                    <input
                      type="text"
                      className=""
                      placeholder="Jan 30, 2025"
                    />
                  </Form>
                </div>

                <div>
                  <Form className="form-scacaz w-50">
                    <p className="mb-3">Status</p>
                    <input type="text" className="" placeholder="Active" />
                  </Form>
                </div>

                <div className="btndiv">
                  <div className="d-flex align-items-center gap-2">
                  <a href="/Modules">
                <button className="div-ButtonGreen">Add Module</button>
              </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddModules;
